import React, {useEffect, useState} from "react";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHButtonIcon from "../../general/DHButtonIcon";
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import BackspaceIcon from '@mui/icons-material/Backspace';
import ConfirmWithQuestionDialog from "../../general/ConfirmWithQuestionDialog";
import DHSwitch from "../../general/DHSwitch";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import DateUtil from "../../../util/DateUtil";

export default function AdminVeranstalterBezahlung() {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [eventOperators, setEventOperators] = useState([]);
    const [payments, setPayments] = useState([]);
    const [selectedPaymentId, setSelectedPaymentId] = useState(undefined);
    const [selectedStornoId, setSelectedStornoId] = useState(undefined);
    const [selectedErinnerungId, setSelectedErinnerungId] = useState(undefined);

    const [zeigeNurNichtBezahlte, setZeigeNurNichtBezahlte] = useState(false);
    const [zeigeNurStorno, setZeigeNurStorno] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.admin + "/eventoperators/payments",
            json => {
                setPayments(json)
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }
    const loadEventOperator = (id) => {
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.admin + "/eventoperator/" + id,
            {},
            json => {
                let newEventOperators = [...eventOperators];
                newEventOperators.push({id: json.id, value: json});
                setEventOperators(newEventOperators);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const storno = () => {
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.admin + "/eventoperator/payment/storno/" + selectedStornoId,
            {},
            () => {
                setSelectedStornoId(undefined);
                loadData();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setSelectedStornoId(undefined);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setSelectedStornoId(undefined);
            }
        );
    }

    const erinnerungSenden = () => {
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.admin + "/eventoperator/payment/erinnerung/" + selectedErinnerungId,
            {},
            () => {
                setInfoMessage("Erinnerung wurde gesendet.");
                setSelectedErinnerungId(undefined);
                loadData();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setSelectedErinnerungId(undefined);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setSelectedErinnerungId(undefined);
            }
        );
    }

    const changeBezahlt = () => {
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.admin + "/eventoperator/payment/change/" + selectedPaymentId,
            {},
            () => {
                setSelectedPaymentId(undefined);
                loadData();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setSelectedPaymentId(undefined);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setSelectedPaymentId(undefined);
            }
        );
    }

    const getEventOperator = (id) => {
        return eventOperators.filter(tmp => tmp.id === id)[0];
    }

    const rows = () => {
        let tmpRows = [];
        for (const tmp of payments) {
            if( zeigeNurStorno && !tmp.storno) {
                continue;
            }
            if( zeigeNurNichtBezahlte && tmp.bezahlt) {
                continue;
            }
            let keyValue = getEventOperator(tmp.eventOperatorId);
            let eventOperator = undefined;
            if( keyValue !== undefined) {
                eventOperator = keyValue.value;
            }
            tmpRows.push(<div key={"id" + tmp.id}>
                <hr/>
                <div style={{display:"flex"}}>
                    <div style={{width:200}}>ReNr: {tmp.rechnungsnummer}</div>
                    <div style={{width:60}}>Bez: {tmp.bezahlt ? "x" : "-"}</div>
                    <div style={{width:200}}>Zeitpunkt: {DateUtil.localDateTimeToString(tmp.timestamp)}</div>
                    <div style={{width:250}}>
                        {eventOperator === undefined &&
                            <DHButtonIcon icon={<RefreshIcon/>} onClick={() => loadEventOperator(tmp.eventOperatorId)}/>
                        }
                        {!tmp.storno &&
                            <DHButtonIcon icon={<EuroSymbolIcon/>} onClick={() => setSelectedPaymentId(tmp.id)}/>
                        }
                        {!tmp.bezahlt && !tmp.storno &&
                            <DHButtonIcon icon={<BackspaceIcon/>} onClick={() => setSelectedStornoId(tmp.id)}/>
                        }
                        {!tmp.bezahlt && !tmp.storno && !tmp.erinnerung1 &&
                            <DHButtonIcon icon={<NotificationsActiveIcon/>} onClick={() => setSelectedErinnerungId(tmp.id)}/>
                        }
                        <a href={ConfigUtil.getConfig().resourceUrls.receipt + "/eventoperator/" + tmp.id}>
                            <DHButtonIcon icon={<DownloadIcon/>} onClick={() => ""}/>
                        </a>
                    </div>
                </div>
                {tmp.storno && <div style={{marginBottom:10}}>
                    --- Diese Rechnung wurde storniert. ---
                </div>}
                {tmp.erinnerung1 && <div style={{marginBottom:10}}>
                    Erinnerung gesendet: {DateUtil.localDateTimeToString(tmp.erinnerung1)}
                </div>}
                <div>
                    <span style={{textDecoration:"underline"}}>Rechnungsdaten<br/></span>
                    Name: {tmp.rechnungName}<br/>
                    Strasse: {tmp.rechnungStrasse}<br/>
                    PLZ/Ort: {tmp.rechnungPlz} {tmp.rechnungOrt}<br/>
                </div>
                {eventOperator !== undefined && <div>
                    <span style={{textDecoration:"underline"}}>Veranstalterdaten<br/></span>
                    Name: {eventOperator.name}<br/>
                    IdShort:  {eventOperator.idShort}<br/>
                </div>}
            </div>);
        }
        return tmpRows;
    }

    return <div style={{textAlign: "left"}}>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div style={{marginBottom:10}}>
            <DHSwitch id={"id-switch"} value={zeigeNurNichtBezahlte} label="Zeige nur nicht bezahlte" onChange={() => setZeigeNurNichtBezahlte(!zeigeNurNichtBezahlte)}/>
        </div>
        <div style={{marginBottom:20}}>
            <DHSwitch id={"id-switch"} value={zeigeNurStorno} label="Zeige nur stornierte" onChange={() => setZeigeNurStorno(!zeigeNurStorno)}/>
        </div>
        {rows()}
        {selectedPaymentId !== undefined && <ConfirmWithQuestionDialog header={"Frage..."}
                                                                       textOben={"Soll der Bezahlstatus verändert werden?"} textUnten={""}
                                                                       visible={true}
                                                                       callBackOnNein={() => setSelectedPaymentId(undefined)}
                                                                       callBackOnJa={() => changeBezahlt()}/>
        }
        {selectedStornoId !== undefined && <ConfirmWithQuestionDialog header={"Frage..."}
                                                                       textOben={"Soll diese Rechnung storniert werden?"} textUnten={""}
                                                                       visible={true}
                                                                       callBackOnNein={() => setSelectedStornoId(undefined)}
                                                                       callBackOnJa={() => storno()}/>
        }
        {selectedErinnerungId !== undefined && <ConfirmWithQuestionDialog header={"Frage..."}
                                                                          textOben={"Soll eine Zahlungserinnerung an die Rechnungs-Email des Veranstalters gesendet werden?"} textUnten={""}
                                                                          visible={true}
                                                                          callBackOnNein={() => setSelectedErinnerungId(undefined)}
                                                                          callBackOnJa={() => erinnerungSenden()}/>
        }
    </div>
}